import { Auth, CognitoUser } from "@aws-amplify/auth";

export const refreshSession = async (user: CognitoUser): Promise<any> => {
  const session = await Auth.currentSession();

  return new Promise((resolve) =>
    user.refreshSession(session.getRefreshToken(), (err, s) => resolve(s))
  );
};
